import * as React from 'react';
import { WilliamHillLogo } from './components/WilliamHillLogo/WilliamHillLogo';
import './Header.scss';
import { CLASSNAME_PREFIX } from './componentConfig';
var Header = function () { return (React.createElement("header", { className: "".concat(CLASSNAME_PREFIX, "-component") },
    React.createElement(WilliamHillLogo, null))); };
export default React.memo(Header);
//# sourceMappingURL=Header.js.map